/**
 * Unit conversion helpers.
 *
 * All polar maths runs in km/h (airspeed) and m/s (sink rate) internally.
 * Conversion happens only at the display boundary.
 */

const KMH_PER_KT = 1.852;
const MS_PER_KT = 0.5144444;

export const ktToKmh = (kt: number): number => kt * KMH_PER_KT;
export const kmhToKt = (kmh: number): number => kmh / KMH_PER_KT;
export const ktToMs = (kt: number): number => kt * MS_PER_KT;
export const msToKt = (ms: number): number => ms / MS_PER_KT;
